import React from 'react';

export const AlertTriangle = () => (
    <>
        <line x1='12' y1='8' x2='12' y2='12' />
        <line x1='12' y1='15' x2='12' y2='16' />
        <path d='M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75' />
    </>
);